import HistoricalWeatherData from "./HistoricalWeatherData";

export default HistoricalWeatherData;